(() => {
	const overlay  = document.getElementById('mini-cart-overlay');
	const drawer   = document.getElementById('mini-cart');
	const trigger  = document.getElementById('cart-trigger');
	const closeBtn = document.getElementById('mini-cart-close');

	if (!drawer || !trigger) return;

	// --- open / close ---

	const open = () => {
		overlay?.classList.add('is-open');
		drawer.classList.add('is-open');
		drawer.setAttribute('aria-hidden', 'false');
		drawer.inert = false;
		trigger.setAttribute('aria-expanded', 'true');
		document.body.style.overflow = 'hidden';
	};

	const close = () => {
		overlay?.classList.remove('is-open');
		drawer.classList.remove('is-open');
		drawer.setAttribute('aria-hidden', 'true');
		drawer.inert = true; // закрите вікно — поза фокусом і деревом доступності
		trigger.setAttribute('aria-expanded', 'false');
		document.body.style.overflow = '';
	};

	trigger.addEventListener('click', () => drawer.classList.contains('is-open') ? close() : open());
	closeBtn?.addEventListener('click', close);
	overlay?.addEventListener('click', close);
	document.addEventListener('keydown', e => e.key === 'Escape' && drawer.classList.contains('is-open') && close());

	// --- fragment replacement ---

	const applyFragments = (fragments) => {
		for (const [selector, html] of Object.entries(fragments)) {
			const el = document.querySelector(selector);
			if (el) el.outerHTML = html;
		}
	};

	// --- AJAX cart update ---

	const cartRequest = async (key, qty) => {
		const cfg = window.helixwaveCart;
		if (!cfg?.ajaxUrl) return;

		const body = new FormData();
		body.append('action', 'helixwave_cart_update');
		// Свіжий nonce — з блоку, що приходить у фрагментах кошика (сторінка могла бути з кешу).
		body.append('nonce',  document.getElementById('mini-cart-body')?.dataset.nonce || cfg.nonce);
		body.append('key',    key);
		body.append('qty',    qty);

		try {
			const res  = await fetch(cfg.ajaxUrl, { method: 'POST', body, credentials: 'same-origin' });
			const json = await res.json();
			if (json.success && json.data?.fragments) {
				applyFragments(json.data.fragments);
				bindEvents();
			}
		} catch (_) {}
	};

	// --- bind quantity / remove events ---

	const bindEvents = () => {
		document.querySelectorAll('#mini-cart-body .mini-cart__qty-btn').forEach(btn => {
			btn.addEventListener('click', () => {
				const item = btn.closest('[data-key]');
				if (!item) return;
				const key  = item.dataset.key;
				const valEl = item.querySelector('.mini-cart__qty-val');
				let qty = parseInt(valEl?.textContent || '1', 10);
				qty = btn.dataset.action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
				cartRequest(key, qty);
			});
		});

		document.querySelectorAll('#mini-cart-body .mini-cart__remove').forEach(btn => {
			btn.addEventListener('click', () => cartRequest(btn.dataset.key, 0));
		});
	};

	bindEvents();
})();
